<template>
 
   <v-layout align-start>
    <v-flex>
        <v-toolbar text color="white">
            <v-toolbar-title>Variables Indicador</v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <v-spacer></v-spacer>

                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-3" v-on="on">Nueva Variable Indicador</v-btn>
                    </template>

                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-select v-model="id_objetivo"
                                                :items="nombre_objetivo"  label="Nombre Objetivo">
                                            </v-select>
                                        </v-col>                                        
                                        <v-col cols="12" sm="4" md="4">
                                            <v-text-field v-model="codigo_indicador" label="Codigo Indicador"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="8" md="8">
                                            <v-text-field v-model="nombre_indicador" label="Nombre Indicador"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="12">
                                            <v-text-field v-model="nombre_variable" label="Nombre Variable"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="6" md="6">
                                            <v-select v-model="formato_variable"
                                                :items="formato_variable"  label="Formato Variable">
                                            </v-select>
                                        </v-col>            

                                         <v-col cols="12" sm="6" md="6">
                                            <v-text-field  type="number" v-model="valor_variable" label="Valor Variable"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="12" md="12">
                                            <v-text-field v-model="observaciones_variable" label="Observacion Variable"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="6" md="6">
                                            <v-select v-model="frecuencia_variable"
                                                :items="frecuencia_variable"  label="Frecuencia">
                                            </v-select>
                                        </v-col>  

                                        <v-col cols="12" sm="6" md="6">
                                            <v-select v-model="codigo_responsable_indicador"
                                                :items="nombre_responsable_indicador"  label="Responsable Indicador">
                                            </v-select>
                                        </v-col>                                          
                                    </v-row>
                                    <v-flex xs12 sm12 md12 v-show="valida">
                                        <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">
                                        </div>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click.native="close">Cancelar</v-btn>
                            <v-btn color="red darken-1" text @click.native="guardar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>cd
                </v-dialog>
 
                 <v-dialog v-model="adModal" max-width="290">
                    <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">¿Activar Item? </v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Item? </v-card-title>
                    <v-card-text>
                        Estas a punto del
                        <span v-if="adAccion==1">Activar </span>
                        <span v-if="adAccion==2">Desactivar </span>
                        el item {{ adIdVariable}}    
                    </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text="text" @click="activarDesactivarCerrar">
                                    Cancelar
                                </v-btn>
                                <v-btn v-if="adAccion==1" color="orange darken-4" text="text" @click="activar">
                                    Activar
                                </v-btn>
                                <v-btn v-if="adAccion==2" color="orange darken-4" text="text" @click="desactivar">
                                    Desactivar
                                </v-btn>
                            </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>

   <v-data-table
        :headers="headers"
        :items="variables_indicador"
        :search="search"
        class="elevation-1"
    >     
                <template v-slot:item.action="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                    >
                        mdi-grease-pencil
                    </v-icon>
                    <template v-if="item.estado_variable">
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(2,item)"
                        >
                            mdi-block-helper
                        </v-icon>
                    </template>
                    <template v-else>
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(1,item)"
                        >
                            mdi-check-all
                        </v-icon>
                    </template>
                </template>

                <template slot="items" slot-scope="props">
                    <td>{{ props.item.nombre_objetivo }}</td>
                    <td>{{ props.item.codigo_indicador }}</td>
                    <td>{{ props.item.nombre_indicador }}</td>
                    <td>{{ props.item.nombre_variable }}</td>
                    <td>{{ props.item.formato_variable }}</td>
                    <td>{{ props.item.valor_variable }}</td>
                    <td>{{ props.item.observaciones_variable }}</td>
                    <td>{{ props.item.frecuencia_variable }}</td>
                    <td>{{ props.item.codigo_responsable_indicador }}</td>
                    <td>{{ props.item.nombre_responsable_indicador }}</td>
                    <td>
                        <div v-if="props.item.estado_variable">
                            <span class="blue--text">Activo</span>
                        </div>
                        <div v-else>
                            <span class="red--text">Inactivo</span>
                        </div>
                    </td>
                </template>

                <template slot="no-data">
                <v-btn color="primary" @click="listar">Resetear</v-btn>
                </template>
    </v-data-table>

        </v-flex>
    </v-layout>

</template>

<script>
import axios from 'axios'

export default {
    data(){
        return{
                variables_indicador:[],                
                dialog: false,
                headers: [
                    { text: 'Opciones', value: 'action', sortable: false},
                    { text: 'Objetivo', value: 'nombre_objetivo' },
                    { text: 'Cod. Indicador', value: 'codigo_indicador' },
                    { text: 'Nombre Indicador', value: 'nombre_indicador' },
                    { text: 'Nombre Variable', value: 'nombre_variable' },
                    { text: 'Formato', value: 'formato_variable' },
                    { text: 'Valor Variable', value: 'valor_variable' },
                    { text: 'Observaciones', value: 'observaciones_variable' , sortable: false},
                    { text: 'Frecuencia', value: 'frecuencia_variable', sortable: false },
                   // { text: 'Cod. Responsable', value: 'codigo_responsable_indicador' , sortable: false},
                    { text: 'Responsable Variable', value: 'nombre_responsable_indicador' },
                    { text: 'Estado Variable', value: 'estado_variable' , sortable: false}
                ],
                search: '',
                editedIndex: -1,
                id_objetivo	: '',
                nombre_objetivo	:[
                ] ,
                codigo_indicador: '',
                nombre_indicador: '',
                nombre_variable: '',
                id_formatos_varios:'',
                formato_valor:'',
                formato_variable:['#,##0.00','0.00%','$#,##0.00;-$#,##0.00'],  
                //formato_variable:'',
                valor_variable :0,               
                observaciones_variable: '',
                //frecuencia_variable: '',
                frecuencia_variable: ['Mensual','Trimestral','Semestral','Anual'],
                frecuencia:"",
                codigo_responsable_indicador: '',
                nombre_responsable_indicador:[                    
                ] ,                
                valida: 0,
                validaMensaje:[],
                adModal: 0,
                adAccion: 0,
                adIdVariable:'',
                adNombre:''
        }
    },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Nueva Variable Indicador' : 'Actualizar Variable Indicador'
            }
        },


    watch: {
        dialog (val) {
        val || this.close()
        },
    },

    created () {
        this.listar();
        this.select();
        this.selectFormato();
        this.selectFrecuencia();
        this.selectObjetivo();

    },
    methods:
    {
		listar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};            
			axios.get('api/Hechos_Variables_Indicador/Listar',configuracion).then(function(response){
				//console.log(response);
				me.variables_indicador=response.data;
			}).catch(function(error){
				console.log(error);   
			});
		},

        select(){
            let me=this;
            var responsableindicadorArray= [];
			axios.get('api/Responsables_Indicadores/Select').then(function(response){
                //console.log(response);
                responsableindicadorArray=response.data;
                responsableindicadorArray.map(function(x){
                    me.nombre_responsable_indicador.push({text: x.nombre_responsable_indicador, value:x.codigo_responsable_indicador});
                });
			}).catch(function(error){
				console.log(error);   
			});
        },
        
        selectObjetivo(){   
            let me=this;
            var objetivoindicadorArray= [];
			axios.get('api/Objetivos/Select').then(function(response){
                //console.log(response);
                objetivoindicadorArray=response.data;
                objetivoindicadorArray.map(function(x){
                    me.nombre_objetivo.push({text: x.nombre_objetivo, value:x.id_objetivo});
                });
			}).catch(function(error){
				console.log(error);   
			});
        },
        
        selectFormato(){
            let me=this;
            var formatovariableArray= [];
			axios.get('api/Formatos_Varios/SelectFormato').then(function(response){
                //console.log(response);
                formatovariableArray=response.data;
                formatovariableArray.map(function(x){
                    me.formato_variable.push({text: x.formato_valor, value:x.formato_valor});
                });
			}).catch(function(error){
				console.log(error);   
			});
        },

      selectFrecuencia(){
            let me=this;
            var frecuenciavariableArray= [];
			axios.get('api/Formatos_Varios/SelectFrecuencia').then(function(response){
                //console.log(response);
                frecuenciavariableArray=response.data;
                frecuenciavariableArray.map(function(x){
                    me.frecuencia_variable.push({text: x.frecuencia, value:x.frecuencia});
                });
			}).catch(function(error){
				console.log(error);   
			});
        },
  

        
		editItem (item) {
 			this.adIdVariable=item.id_variable;
 			this.id_objetivo=item.id_objetivo;
			this.codigo_indicador=item.codigo_indicador;
            this.nombre_indicador=item.nombre_indicador;
            this.nombre_variable= item.nombre_variable;
			this.formato_variable=item.formato_variable;
			this.valor_variable=item.valor_variable;
			this.frecuencia_variable=item.frecuencia_variable;
			this.observaciones_variable=item.observaciones_variable;
			this.codigo_responsable_indicador=item.codigo_responsable_indicador;
			this.estado_variable=item.estado_variable;
            this.editedIndex=1;            
			this.dialog = true
		},

		close () {
            this.dialog = false;
            this.limpiar();
		},

		limpiar(){
            this.id_objetivo="";
            this.codigo_indicador="";
            this.nombre_indicador="";
            this.nombre_variable= "";
            this.formato_variable= "";
			this.valor_variable=0;
			this.frecuencia_variable= "";
			this.observaciones_variable=0;
            this.codigo_responsable_indicador="";
			this.editedIndex=-1;
		},


		guardar () {
            
			if(this.validar()){
				return;
			}
			if (this.editedIndex > -1) {
				// codigo para guardar
				let me=this;
				axios.put('api/Hechos_Variables_Indicador/Actualizar',{
                    'id_variable':me.adIdVariable,
                    'id_objetivo':me.id_objetivo,
                    'codigo_indicador': me.codigo_indicador,
                    'nombre_indicador': me.nombre_indicador,
                    'nombre_variable': me.nombre_variable,
					'formato_variable':me.formato_variable,
					'valor_variable':me.valor_variable,
					'frecuencia_variable':me.frecuencia_variable,
					'observaciones_variable':me.observaciones_variable,
					'codigo_responsable_indicador':me.codigo_responsable_indicador
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
				});

			} else {
		   //     this.desserts.push(this.editedItem)
				let me=this;
				axios.post('api/Hechos_Variables_Indicador/Crear',{
                    'id_objetivo':me.id_objetivo,
                    'codigo_indicador': me.codigo_indicador,
                    'nombre_indicador': me.nombre_indicador,
                    'nombre_variable': me.nombre_variable,
					'formato_variable':me.formato_variable,
					'valor_variable':me.valor_variable,
					'frecuencia_variable':me.frecuencia_variable,
					'observaciones_variable':me.observaciones_variable,
					'codigo_responsable_indicador':me.codigo_responsable_indicador
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
                });
                
			}
        },

		validar(){
			this.valida=0;
			this.validaMensaje=[];
			if(!this.nombre_objetivo){
				this.validaMensaje.push("Debe seleccionar un objetivo.");
            }
            if(!this.valor_variable){
				this.validaMensaje.push("Digite un valor para la variable");
            }            
			if(this.nombre_variable < 3 || this.nombre_variable > 100){
				this.validaMensaje.push("El Nombre de la Variable debe tener mas de 3 caracteres y menos de 100 caracteres");
            }
			if(!this.formato_variable){
				this.validaMensaje.push("Debe digitar el nombre de por lo menos una variable ");
            }
			if(!this.observaciones_variable){
				this.validaMensaje.push("Debe digitar un aobservacion ");
            }
		    if(this.validaMensaje.length){
				this.valida=1;
			}
		    return this.valida;
        },

        activarDesactivarMostrar(accion,item){
        this.adModal=1;
        this.adIdVariable=item.id_variable;
        if (accion==1){
            this.adAccion=1;
        }
        else if (accion==2){
        this.adAccion=2;
        }
        else{
        this.adModal=0;
        }
        },
        activarDesactivarCerrar(){
        this.adModal=0;
        },
        activar(){
            let me=this;
            axios.put('api/Hechos_Indicador/Activar/'+this.adIdVariable,{}).then(function(response){
            me.adModal=0;
            me.adAccion=0;
            me.adNombre="";
            me.adIdVariable="";
            me.listar();                       
            }).catch(function(error){
                console.log(error);
            });
        },
        desactivar(){
            let me=this;
            axios.put('api/Hechos_Indicador/Desactivar/'+this.adIdVariable,{}).then(function(response){
                me.adModal=0;
                me.adAccion=0;
                me.adIdVariable="";
                me.adNombre="";
                me.listar();                       
            }).catch(function(error){
            console.log(error);
        });
            }
        }        
    }
</script>